import script from "./WChatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./WChatMessage.vue?vue&type=script&setup=true&lang=js"

import "./WChatMessage.vue?vue&type=style&index=0&id=10333ca2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10333ca2"]])

export default __exports__